export default __webpack_public_path__ + "locales/tr/People.json?hash=d9d0598db947109a1941097bd765a58d";